define('module/toggle',[
    'jquery',
    'underscore',
    'cnf'
], function($,_,Cnf) {
    'use strict';
    
    return function()
    {
        this.options={
            selector:{
                trigger:'.trigger-toggle'
            },
            data:{
                toggle_target:'toggle_target',
                toggle_vars:'toggle_vars',
                toggle:'toggle'
            }
        };
        
        this.init=function()
        {
            this.initOptions();
            this.initToggle();
        };
        
        this.initOptions=function()
        {
            this.oToggle={};
            this.$toggle=Cnf.$app.find(this.options.selector.trigger);
            this.iToggle=this.$toggle.length;
        };
        
        this.initToggle=function()
        {
            if(this.iToggle<=0) {
                return;
            }
            
            for(var i=0;i<this.iToggle;i++) {
                
                this.oToggle[i]={
                    busy:false,
                    $toggle:this.$toggle.eq(i),
                    $target:this.$toggle.eq(i).closest(this.$toggle.eq(i).data(this.options.data.toggle_target)),
                    vars:this.$toggle.eq(i).data(this.options.data.toggle_vars),
                    current:this.$toggle.eq(i).data(this.options.data.toggle_vars)[0]
                };
                
                //add listener
                this.oToggle[i].$toggle.on(Cnf.click, _.bind(this.triggerToggle,this,i));
            }
        };
        
        this.triggerToggle=function(i)
        {
            var index=this.oToggle[i].vars.indexOf(this.oToggle[i].current) +1;
            if(index>=this.oToggle[i].vars.length) {
                index=0;
            }
            
            this.oToggle[i].current=this.oToggle[i].vars[index];
            this.oToggle[i].$target.attr('data-' + this.options.data.toggle, this.oToggle[i].current);
        };
        
        this.init();
    };
});
